import React from 'react';
import { Prospect } from 'types/common';
import { opsGetPatientDetail } from 'api/operation';

const useOpsPatientInfo = (id?: number): [Prospect | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<Prospect>();
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await opsGetPatientDetail(id!);
            if (!result.error) {
                const data: Prospect = result.data?.data;
                if (data.insurances) {
                    data.insurances.sort((a, b) => {
                        if (!a.sort) {
                            return 1;
                        }
                        if (!b.sort) {
                            return -1;
                        }
                        return a.sort - b.sort;
                    });
                }
                setItem(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && id) {
            fetchData();
        }
    }, [id]);

    return [item, loading, fetchData];
};

export default useOpsPatientInfo;
